import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import VueAxios from 'vue-axios'
import axios from 'axios'
import moment from 'moment'
import 'animate.css';
import Vant from 'vant';
import 'vant/lib/index.css';
import 'vant/lib/index.less';
import { Locale } from 'vant';
import zhTW from 'vant/es/locale/lang/zh-TW';
Locale.use('zh-TW', zhTW);
import { Lazyload } from 'vant';
import { Toast } from 'vant';
import { Dialog } from 'vant';

import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import 'element-ui/lib/theme-chalk/display.css';
import '@vant/touch-emulator';

import path from "path";
Vue.prototype.$path = path;
import { firestorePlugin } from 'vuefire'
// import { db } from '@/lib-firebase';
Vue.use(firestorePlugin);

Vue.prototype.$http = axios;
Vue.prototype.$moment = moment;
Vue.use(ElementUI);
Vue.use(Lazyload);
Vue.use(VueAxios, axios)
Vue.use(Toast);
Vue.use(Dialog);
Vue.use(Vant);


//專案用vue mixin
import vueBase from './vue/vueBase.js'
import vueApi from './vue/vueApi.js'
import vueMe from './vue/vueMe.js'
Vue.mixin(vueBase);
Vue.mixin(vueApi);
Vue.mixin(vueMe);

import vueMpo from './vue/vueMpo.js'
Vue.mixin(vueMpo);



//封裝好的vant組件
// import NumPicker from './components/Vant/FrmNumPicker.vue';
// import DataPicker from './components/Vant/FrmDataPicker.vue';
// import CheckboxPicker from './components/Vant/FrmCheckboxPicker.vue';
// import RadioPicker from './components/Vant/FrmRadioPicker.vue';
// import DatePicker from './components/Vant/FrmDatePicker.vue';
// import CalendarPicker from './components/Vant/FrmCalendarPicker.vue';
// import Collapse from './components/Vant/Collapse.vue';
// import Popover from './components/Vant/Popover.vue';
// import NavBar from '@/components/NavBar.vue';
// Vue.component('NumPicker', NumPicker);
// Vue.component('DataPicker', DataPicker);
// Vue.component('DatePicker', DatePicker);
// Vue.component('CheckboxPicker', CheckboxPicker);
// Vue.component('RadioPicker', RadioPicker);
// Vue.component('CalendarPicker', CalendarPicker);
// Vue.component('Collapse', Collapse);
// Vue.component('Popover', Popover);
// Vue.component('NavBar', NavBar);

// import GRadio from './components/GRadio.vue';
// import GCheckBox from './components/GCheckBox.vue';
// import GBtnNumber from './components/GBtnNumber.vue';
// Vue.component('GRadio', GRadio);
// Vue.component('GCheckBox', GCheckBox);
// Vue.component('GBtnNumber', GBtnNumber);

// Woosa


import Header from './components/Header';
Vue.component('Header', Header);


import FrmEditType from './components/BKMenu/Popup/FrmEditType';
import FrmEditItem from './components/BKMenu/Popup/FrmEditItem';
import FrmEditGroup from './components/BKMenu/Popup/FrmEditGroup';
import ImagePick from './components/BKMenu/Popup/Child/ImagePick';
import FrmItemDetail from './components/BKMenu/Popup/Child/FrmItemDetail';
import FrmItemDetailGroup from './components/BKTable/Popup/Popup/FrmItemDetailGroup';
import ItemGroups from './components/BKTable/Popup/Popup/Child/ItemGroups';

import Discount from './components/BKMenu/Popup/Child/Discount';
import Radios from './components/BKMenu/Popup/Child/Radios';
import Input from './components/UI/Input';
import InputArea from './components/UI/InputArea';
import CheckBox from './components/UI/CheckBox';
import ColorPicker from './components/UI/ColorPicker';
import CheckBoxG from './components/UI/CheckBoxG';
import RadioGroup from './components/UI/RadioGroup';
import ImagePicker from './components/UI/ImagePicker';



Vue.component('ImagePick', ImagePick);
Vue.component('FrmEditType', FrmEditType);
Vue.component('FrmEditItem', FrmEditItem);
Vue.component('FrmEditGroup', FrmEditGroup);
Vue.component('FrmItemDetail', FrmItemDetail);
Vue.component('FrmItemDetailGroup', FrmItemDetailGroup);
Vue.component('ItemGroups', ItemGroups);
Vue.component('Discount', Discount);
Vue.component('Radio', Radios);
Vue.component('Input', Input);
Vue.component('InputArea', InputArea);
Vue.component('CheckBox', CheckBox);
Vue.component('ColorPicker', ColorPicker);
Vue.component('CheckBoxG', CheckBoxG);
Vue.component('RadioGroup', RadioGroup);
Vue.component('ImagePicker', ImagePicker);

new Vue({
    router,
    store,
    // data: () => ({ xxcode: [] }), // root.data
    // firestore: {
    //     xxcode: db.collection("xxcode") //使用plugin將快照轉成json
    // },
    render: h => h(App)
}).$mount('#app')